/* Imports needed for all question form subclasses. */
import * as React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import {
    mapStateToQuestionFormBaseProps,
    mapDispatchToQuestionFormBaseProps
} from '../../QuestionFormBase';

import {
    QuestionFormWithOptionsBase,
    QuestionFormWithOptionsBaseProps,
    QuestionFormWithOptionsBaseStates
} from '../QuestionFormWithOptionsBase';
import { MULTIMEDIA_TYPES, PROJECT_STATUS, QTYPES } from '@nexxt/common/types';
import NotifyHOC from '../../../../../../HOC/Notifications';
/* Components used in this question form. */
import BuilderHeader from '../../../common/builderHeader';
import QuestionSettings from '../../../common/questionSettings';
import Options from '../../../common/Options';
import MultimediaBubble from '../../../common/MultimediaBubble';

interface Props extends QuestionFormWithOptionsBaseProps {
    // nothing special... yet!
}

interface States extends QuestionFormWithOptionsBaseStates {
    // nothing special... yet!
}
class FormChoice extends QuestionFormWithOptionsBase<Props, States> {
    constructor(p: QuestionFormWithOptionsBaseProps) {
        super(p, QTYPES.SINGLE_CHOICE);
        const question = {
            ...this.state.question,
            showContinueButton:
                this.state.question.type === QTYPES.MULTIPLE_CHOICE
                    ? true
                    : false
        };
        this.state = {
            ...this.state,
            question
        };
    }
    componentDidUpdate(
        prevProps: Readonly<Props>,
        prevState: Readonly<States>
    ): void {
        super.componentDidUpdate(prevProps, prevState);
        if (prevState.question.type !== this.state.question.type) {
            this.setState(
                (prevState) => ({
                    ...prevState,
                    question: {
                        ...prevState.question,
                        showContinueButton:
                            prevState.question.type === QTYPES.SINGLE_CHOICE
                                ? false
                                : true
                    }
                }),
                this.setEditFlag
            );
        }
    }
    render() {
        const { currentProject, currentQuestionId } = this.props;
        const { question, isSettingBoxLayoutOpen } = this.state;
        const questionError =
            (this.state.showError && this.state.questionError) || {};

        return (
            <div>
                <div className="project-add--question-builder">
                    <BuilderHeader
                        toggleSettingBoxLayout={this.toggleSettingBoxLayout}
                        isSettingBoxLayoutOpen={isSettingBoxLayoutOpen}
                        showAlert={!this.props.editEnabled}
                        alertMessages={this.getWarningMessage()}
                        question={question}
                        setValue={this.setQuestion}
                        disabled={!this.props.editEnabled}
                        errorObject={this.state.questionError}
                    />
                    <div className="builder-body">
                        {(isSettingBoxLayoutOpen && (
                            <QuestionSettings
                                onClose={this.toggleSettingBoxLayout}
                                question={question}
                                questionSettings={{
                                    allowUserEdit: true
                                }}
                                setValue={this.setQuestion}
                                disabled={!this.props.editEnabled}
                            />
                        )) ||
                            null}
                        {this.renderErrorNotes()}
                        <MultimediaBubble
                            question={question}
                            languages={currentProject.languages}
                            setValue={this.setQuestion}
                            setValueWithLanguage={
                                this.NEW_setQuestionTextTranslation
                            }
                            addNewBubble={this.NEW_addNewEditor}
                            removeBubble={this.NEW_removeEditor}
                            disabled={!this.props.editEnabled}
                            questionError={questionError || {}}
                            settings={{ showClose: true }}
                        />
                    </div>
                    <div>
                        <Options
                            question={question}
                            setQuestionAsQuestion={this.setQuestionAsQuestion}
                            setQuestion={this.setQuestion}
                            setQuestionWithLanguage={
                                this.setQuestionWithLanguage
                            }
                            questionSummaries={this.props.questionSummaries}
                            setMultimediaText={
                                this.NEW_setQuestionTextTranslation
                            }
                            setOtherOptionWithLanguage={
                                this.setOtherOptionWithLanguage
                            }
                            handleOptions={this.handleOptions}
                            languages={currentProject.languages}
                            countries={currentProject.countries}
                            error={this.state.questionError || {}}
                            showError={this.state.showError}
                            disabled={!this.props.editEnabled}
                            projectHealthOptionIds={this.getProjectHealthOptionIds()}
                            isLive={
                                currentProject.status == PROJECT_STATUS.LIVE
                            }
                            previousPackageQuestion={
                                (currentProject.previousPackage &&
                                    currentProject.previousPackage.questions.find(
                                        (q) => q.id == question.id
                                    )) ||
                                null
                            }
                        />
                    </div>
                    {/** CONTINUE BUTTON */}
                    {this.state.question.type === QTYPES.MULTIPLE_CHOICE && (
                        <MultimediaBubble
                            languages={currentProject.languages}
                            question={question}
                            setValue={this.setQuestion}
                            setValueWithLanguage={
                                this.NEW_setQuestionTextTranslation
                            }
                            questionError={questionError}
                            keyName="continueTexts"
                            disabled={!this.props.editEnabled}
                            disableAddBubble
                            defaultTextType={MULTIMEDIA_TYPES.TEXT}
                            defaultText="BUTTON.CONTINUE"
                            questionText="Continue button text"
                            settings={{
                                noBorder: true,
                                useTranslation: true
                            }}
                        />
                    )}
                    {/*end of builder body*/}
                </div>
            </div>
        );
    }
}

export default withRouter(
    NotifyHOC(
        connect(
            mapStateToQuestionFormBaseProps,
            mapDispatchToQuestionFormBaseProps
        )(FormChoice)
    )
);
